$(() => {
    $('*[data-sectiontarget]').each(function (index, element) {
        if ($(element).attr('data-sectiontarget') != '') {
            var target = $(element).attr('data-sectiontarget');
            var section = $('*[data-section="' + target + '"]');
            if (!$(section).is(":hidden") || $(section).hasClass("section") || $(section).hasClass("current")) {
                $(element).addClass("gh__SideNav__items--item--caret-expanded");
            } else {
                $(element).addClass("gh__SideNav__items--item--caret-collapsed");
            }
        }
    });
    $(".js__SideNav__caret").click(function (event) {
        event.preventDefault();
        var target = $(this).attr('data-sectiontarget');
        var section = $('*[data-section="' + target + '"]');
        $(section).toggle();
        if ($(section).is(":visible")) {
            $(this).removeClass("gh__SideNav__items--item--caret-collapsed").addClass("gh__SideNav__items--item--caret-expanded");
        } else {
            $(this).removeClass("gh__SideNav__items--item--caret-expanded").addClass("gh__SideNav__items--item--caret-collapsed");
        }

    });
});



// WEBPACK FOOTER //
// Glasshouse/Core/js/navigation-sidebar.js